import React, { useState, useEffect, useRef, Fragment } from "react";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import style from "./style";
import { NavLink, useLocation } from "react-router-dom";
import { IMG_WHITE_LOGO, IMG_BLOB } from "../../../constants/images";
import { AVATAR_ANIMATION } from "../../../constants/animations";
import {
  Typography,
  Breadcrumbs,
  Button,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  MenuList,
  Box,
} from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { IsMobile } from "./../../../utils/utils";
import lottie from "lottie-web";
import { ROUTE_BREADCRUMBS } from "../../../constants/routes";
import { useTranslation } from "react-i18next";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import GroupsIcon from "@mui/icons-material/Diversity3Outlined";
import UsersIcon from "@mui/icons-material/GroupOutlined";
import ProfileIcon from "@mui/icons-material/VerifiedUserOutlined";
import ActionIcon from "@mui/icons-material/PanToolOutlined";
import ModulesIcon from "@mui/icons-material/AppRegistrationOutlined";

import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import {
  showActionsReducer,
  showGroupsReducer,
  showModulesReducer,
  showResponsivasReducer,
  showRolesReducer,
  showUsersReducer,
} from "../../../store/reducers/app";
import ResponsivasNavBarButton from "../../Responsivas/ResponsivasNavBarButton";

const AppNavBar = (props) => {
  const { t } = useTranslation();
  const { onBarClick, userMenuHandler } = props;
  const user = useSelector((state) => state.user.user);
  const dispatch = useDispatch();
  const isMobile = IsMobile();
  const classes = style();
  const animationRef = useRef(null);
  const avatarAnimationRef = useRef(null);
  const location = useLocation();
  const [routeBreadcrumbs, setRouteBreadcrumbs] = useState(null);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    if (animationRef.current) {
      avatarAnimationRef.current = lottie.loadAnimation({
        container: animationRef.current,
        renderer: "svg",
        loop: false,
        autoplay: true,
        path: AVATAR_ANIMATION,
      });
    }
  }, []);

  useEffect(() => {
    setRouteBreadcrumbs(location && location.pathname ? ROUTE_BREADCRUMBS[location.pathname] || null : null);
  }, [location]);

  const avatarMouseEnterHandler = () => {
    if (avatarAnimationRef.current) {
      avatarAnimationRef.current.goToAndStop(0);
      avatarAnimationRef.current.play();
    }
  };

  const showRolesHandler = () => {
    dispatch(showRolesReducer(true));
    handleClose();
  };
  const showUsersHandler = () => {
    dispatch(showUsersReducer(true));
    handleClose();
  };
  const showGroupsHandler = () => {
    dispatch(showGroupsReducer(true));
    handleClose();
  };
  const showActionsHandler = () => {
    dispatch(showActionsReducer(true));
    handleClose();
  };
  const showModulesHandler = () => {
    dispatch(showModulesReducer(true));
    handleClose();
  };

  return (
    <div>
      <AppBar
        position="relative"
        onClick={onBarClick}
        color="primary"
        className={["z-l3", classes.appBarContainer].join(" ")}
      >
        <Toolbar className={[classes.appBar, "d-flex justify-content-between container"].join(" ")}>
          <div className="d-flex align-items-center">
            <NavLink to={`/`}>
              <img src={IMG_WHITE_LOGO} className={[classes.logo].join(" ")} alt="" />
            </NavLink>
            <div className="d-flex align-items-center ml-2">
              <div className={classes.navbarTitle}>
                <Typography variant="h1" className={[classes.title].join(" ")}>
                  {t("title")}
                </Typography>
                <Typography variant="h4" className={[classes.subtitle].join(" ")}>
                  {t("subtitle")}
                </Typography>
              </div>
            </div>
          </div>
          <div className="d-flex align-items-center">
            {user.getResponsibleApps().length > 0 && <ResponsivasNavBarButton />}
            {user.getIsAdmin() && (
              <Fragment>
                <Button
                  id="basic-button"
                  aria-controls={open ? "basic-menu" : undefined}
                  aria-haspopup="true"
                  aria-expanded={open ? "true" : undefined}
                  onClick={handleClick}
                  className="mr-5 btn-users-management"
                  variant="contained"
                >
                  <SettingsOutlinedIcon className={!isMobile ? "mr-2" : ""} />
                  {!isMobile && t("userManagement.title")}
                </Button>
                <Menu
                  id="basic-menu"
                  anchorEl={anchorEl}
                  open={open}
                  onClose={handleClose}
                  MenuListProps={{
                    "aria-labelledby": "basic-button",
                  }}
                >
                  <MenuList sx={{ minWidth: 220 }}>
                    <MenuItem onClick={showGroupsHandler}>
                      <ListItemIcon>
                        <GroupsIcon fontSize="small" />
                      </ListItemIcon>
                      <ListItemText>{t("userManagement.groups")}</ListItemText>
                    </MenuItem>
                    <MenuItem onClick={showUsersHandler}>
                      <ListItemIcon>
                        <UsersIcon fontSize="small" />
                      </ListItemIcon>
                      <ListItemText>{t("userManagement.users")}</ListItemText>
                    </MenuItem>
                    <MenuItem onClick={showRolesHandler}>
                      <ListItemIcon>
                        <ProfileIcon fontSize="small" />
                      </ListItemIcon>
                      <ListItemText>{t("userManagement.roles")}</ListItemText>
                    </MenuItem>
                    <MenuItem onClick={showActionsHandler}>
                      <ListItemIcon>
                        <ActionIcon fontSize="small" />
                      </ListItemIcon>
                      <ListItemText>{t("userManagement.actions")}</ListItemText>
                    </MenuItem>
                    {user.getIsAdmin() && (
                      <MenuItem onClick={showModulesHandler}>
                        <ListItemIcon>
                          <ModulesIcon fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>{t("userManagement.modules")}</ListItemText>
                      </MenuItem>
                    )}
                  </MenuList>
                </Menu>
              </Fragment>
            )}
            <Box
              className={[classes.avatar, "bg-cover"].join(" ")}
              ref={!user.getImage() ? animationRef : null}
              onMouseEnter={avatarMouseEnterHandler}
              onClick={userMenuHandler}
              sx={user.getImage() ? { background: `url(${user.getImage()})` } : {}}
            />
          </div>
        </Toolbar>
        <img src={IMG_BLOB} alt="" className={classes.headerImage} />
      </AppBar>
    </div>
  );
};

export default AppNavBar;

const BreadcrumbsContainer = ({ routeBreadcrumbs, extra }) => {
  const classes = style();
  const { t } = useTranslation();
  return (
    <Breadcrumbs separator={<ChevronRightIcon size={14} />} aria-label="breadcrumb" className={classes.breadcrumbs}>
      {/* <Typography color="textPrimary">OBO</Typography> */}
      {routeBreadcrumbs.parents &&
        routeBreadcrumbs.parents.map((p) => (
          <Typography key={p.title} color="textPrimary">
            {t(p.title)}
          </Typography>
        ))}

      <Typography color="primary" variant="h5">
        {t(routeBreadcrumbs.title)}
      </Typography>
      {extra && (
        <Typography color="primary" variant="h5">
          {extra}
        </Typography>
      )}
    </Breadcrumbs>
  );
};
